import React, {Component} from 'react';
import Button from '../inputs/button';
import Constants from '../../../../definitions/constants';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import FullScreenGlassLoading from './fullScreenGlassLoading';

class GlassPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.props.loadingButton != prevProps.loadingButton && this.props.loadingButton == false
       && this.props.type == Constants.interface.popup.types.LATERAL && this.contentArticle) {
      this.contentArticle.scrollTop = 0;
    }
  }
  
  render() {
    const {
      className,
      type,
      handleShowPopup,
      handleButton,
      handleRefresh,
      handleExtraButton,
      extraButtonIcon,
      buttonText,
      loadingButton,
      handleAlternativeButton,
      alternativeButtonText,
      loadingAlternativeButton,
      alternativeButtonClass,
      fullLoading,
      title,
      popupState,
      children
    } = this.props;
    if(!InterfaceTooling.popupHasToRender(popupState)) {
      return null;
    }
    return (
      <div className={
          "glass_popup glass_popup_" + 
          (type ? type : Constants.interface.popup.types.CENTERED) + 
          (className ? " " + className : "") +
          ((popupState && popupState.show) ? " glass_popup_visible" : "")
      }>
        <label className="modal-bg" onClick={handleShowPopup}></label>
        <div className="modal-content">
          <header>
            <h2>{title}</h2>
            {(handleExtraButton) && (
              <label className="popup-extra-button">
                <i className={"fas fa-"+extraButtonIcon} onClick={handleExtraButton}></i>
              </label>
            )}
            {(handleRefresh) && (
              <label className="refresh">
                <i className="fas fa-sync" onClick={handleRefresh}></i>
              </label>
            )}
            <label className="close">
              <i className="fas fa-times-circle" onClick={handleShowPopup} id="glass_popup_close_button"></i>
            </label>
          </header>
          <article className="content glass_popup_content" ref={(input) => { this.contentArticle = input; }}>
            {children}
          </article>
          <footer>
            {handleAlternativeButton && (
              <Button
                disabled={loadingAlternativeButton}
                loading={loadingAlternativeButton}
                onClick={handleAlternativeButton}
                labelLocale={alternativeButtonText}
                className={"alternative_button " + (alternativeButtonClass ? alternativeButtonClass : "")}
              />
            )}
            {handleButton && (
              <Button
                disabled={loadingButton}
                loading={loadingButton}
                onClick={handleButton}
                labelLocale={buttonText}
              />
            )}
          </footer>
          {(fullLoading) && (<FullScreenGlassLoading/>)}
        </div>
      </div>
    );
  };
}

export default GlassPopup;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/glassPopup.jsx